export default response => {
  return response.status === 404;
};



// WEBPACK FOOTER //
// ./src/utils/responseIs404.js